import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M8 0C13.3341 0 16 2.66588 16 8C16 13.3341 13.3341 16 8 16C2.66588 16 0 13.3341 0 8C0 2.66588 2.66588 0 8 0Z",
      fill: "#A38F8F"
    }, null, -1),
    _createElementVNode("path", {
      d: "M3.10498 10.7718C3.10498 7.53309 5.27307 4.02499 9.45151 3.34855C9.45151 3.34855 10.7028 3.12503 11.3065 3.36149C11.533 3.43207 11.8402 3.69677 11.8971 4.01676C12.0359 4.56968 11.5152 5.02142 11.4844 5.0473C11.514 5.05789 11.96 5.22024 12.0466 5.62022C12.1249 5.98374 11.8734 6.27667 11.4263 6.4296C12.1687 7.09781 12.0122 8.43423 11.316 9.0648C12.3028 9.17656 13.0678 9.81418 13.0678 10.7718C13.0678 11.4518 11.4073 11.7235 8.08519 11.7235C4.76307 11.7235 3.10498 11.4518 3.10498 10.7718Z",
      fill: "#D1C7C7"
    }, null, -1)
  ]))]))
}
export default { render: render }